import style from "./card.module.css";
function Card({ className = "", ...props }) {
  return (
    <div className={style.card + (className ? " " + className : "")} {...props}>
      {props.children}
    </div>
  );
}

export default Card;
